module.exports = __webpack_public_path__ + "img/teachingmanagement_6.e09e5e09.jpg";